import React, {useEffect, useState} from "react";
import {
    crearBeneficioAPI,
    getTiposBeneficioItemAPI, getUbicacionesBeneficioItemAPI
} from "../../../../consumers/backendApisUrls";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import {usePropsInputs} from "../../../../hooks/useProps/usePropsInput";
import BaseItem from "./BaseItem";
import {useGetOptionsSelect} from "../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import {usePropsSelect} from "../../../../hooks/useProps/usePropsSelect";
import {initialAllOptionPromises} from "../../../../helper/utils";

const CrearItem = ({toggleModal, refreshPage}) => {
    const SECTION_NAME = "CrearNuevoBeneficio";
    const KEYS = {
        Descripcion: "Descripcion",
        Monto: "Monto",
        ImagenBeneficio: "File",
        Detalle: "Detalle",
        IdTipoBeneficioItem: "IdTipoBeneficioItem",
        IdUbicacionBeneficioItem: "IdUbicacionBeneficioItem"
    };

    const KEYS_DROPDOWN = ["IdTipoBeneficioItem","IdUbicacionBeneficioItem"];

    const [formValues, setFormValues] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [submitForm] = useSubmitForm();

    const [allDropdowns, setAllDropdowns] = useState([]);
    const [getOption] = useGetOptionsSelect();
    const [selectProps] = usePropsSelect(
        allDropdowns,
        formValues,
        setFormValues,
        SECTION_NAME
    );

    useEffect(() => {
        getDropdowns();
    }, [])

    const getDropdowns = async () => {
        const dropdownsPromises = () => [
            getOption(getTiposBeneficioItemAPI()),
            getOption(getUbicacionesBeneficioItemAPI()),
        ]
        await initialAllOptionPromises(dropdownsPromises, KEYS_DROPDOWN, handleDropdowns);
    }

    const handleDropdowns = (data) => {
        const updatedData = [...data];
        setAllDropdowns(updatedData);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const api = crearBeneficioAPI();
        const payload = formValues;
        try {
            await submitForm(
                Object.values(KEYS),
                api,
                payload,
                SECTION_NAME,
                successSubmit
            );
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const successSubmit = async () => {
        toggleModal();
        await refreshPage();
    };

    return (
        <BaseItem
            toggleModal={toggleModal}
            title="Nuevo Ítem"
            puedeEditar={true}
            sectionName={SECTION_NAME}
            KEYS={KEYS}
            formValues={formValues}
            setFormValues={setFormValues}
            commonProps={commonProps}
            isUploading={isUploading}
            setIsUploading={setIsUploading}
            isSubmitting={isSubmitting}
            handleSubmit={handleSubmit}
            selectProps={selectProps}
        />
    );
};

export default CrearItem;